export type EmailDraftErrorCode = "attachment_failed" | "draft_build_failed";

/** A failure the user can act on, with a stable code for the trace. */
export class EmailDraftError extends Error {
  readonly code: EmailDraftErrorCode;

  constructor(code: EmailDraftErrorCode, message: string, cause?: unknown) {
    super(message, { cause });
    this.name = "EmailDraftError";
    this.code = code;
  }
}

export function draftErrorMessage(error: unknown): string {
  return error instanceof EmailDraftError
    ? error.message
    : "The email draft could not be prepared.";
}
